import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";

const PER_PAGE = 6;

export default function News() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  const [page, setPage] = useState(1);

  useEffect(() => { api.get("/content/news?published_only=true").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const filtered = items.filter((i) =>
    (cat === "All" || i.category === cat) &&
    (i.title?.toLowerCase().includes(q.toLowerCase()) || i.excerpt?.toLowerCase().includes(q.toLowerCase()))
  );
  const pages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
  const shown = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  return (
    <div>
      <PageHero overline="Insights" title="Market News & Analysis" subtitle="Research and commentary from the Cresent desk." />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container">
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <div className="relative flex-1">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search articles..." className="w-full bg-white border border-slate-200 rounded pl-10 pr-4 py-2.5 text-sm text-[#0B1D40] placeholder-slate-500 focus:border-[#D8AE4E]/50 outline-none" data-testid="news-search" />
            </div>
            <div className="flex flex-wrap gap-2">
              {cats.map((c) => (
                <button key={c} onClick={() => { setCat(c); setPage(1); }} className={`px-3 py-2 text-sm rounded transition-colors ${cat === c ? "btn-gold" : "text-slate-700 border border-slate-200 hover:border-[#D8AE4E]/50"}`} data-testid={`news-cat-${c.toLowerCase()}`}>{c}</button>
              ))}
            </div>
          </div>

          {shown.length === 0 ? (
            <p className="text-slate-500">No articles found.</p>
          ) : (
            <div className="grid md:grid-cols-3 gap-6">
              {shown.map((n) => (
                <Link to={`/news/${n.id}`} key={n.id} className="cb-card p-6 block" data-testid={`news-item-${n.id}`}>
                  {n.category && <span className="overline">{n.category}</span>}
                  <h3 className="font-serif text-xl text-[#0B1D40] mt-2 mb-2">{n.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed line-clamp-3">{n.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-sm gold-text mt-4">Read more <ArrowRight size={14} /></span>
                </Link>
              ))}
            </div>
          )}

          {pages > 1 && (
            <div className="flex justify-center gap-2 mt-10">
              {Array.from({ length: pages }).map((_, i) => (
                <button key={i} onClick={() => setPage(i + 1)} className={`w-9 h-9 rounded text-sm ${page === i + 1 ? "btn-gold" : "border border-slate-200 text-slate-700"}`} data-testid={`news-page-${i + 1}`}>{i + 1}</button>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
